import React, { useMemo } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { ServicePlanModel } from '@user/store/map/typings'
import {
  getRecurrenceLabel,
  getServiceStatusInfo,
} from '../utils/serviceStatus'
import { ServiceStatusChip } from './ServiceStatusChip'

interface ServiceListItemProps {
  service: ServicePlanModel
}

export function ServiceListItem({ service }: ServiceListItemProps) {
  const status = useMemo(() => getServiceStatusInfo(service), [service])
  const recurrence = useMemo(() => getRecurrenceLabel(service), [service])

  return (
    <Box
      sx={{
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-of-type': {
          borderBottom: 'none',
          pb: 0,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Typography variant="subtitle2">{service.name || '-'}</Typography>
        {status.label ? (
          <ServiceStatusChip label={status.label} kind={status.kind} />
        ) : null}
      </Box>

      {recurrence ? (
        <Chip
          label={recurrence}
          size="small"
          sx={{
            mt: 0.5,
            backgroundColor: '#EAEEF2',
            color: 'text.primary',
          }}
        />
      ) : null}

      <Typography
        variant="caption"
        sx={{ display: 'block', mt: 1, color: 'text.primary' }}
      >
        {status.dateLabel}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <CalendarTodayIcon sx={{ fontSize: 14, color: 'text.primary' }} />
        <Typography variant="body2">{status.dateValue}</Typography>
      </Box>
    </Box>
  )
}

ServiceListItem.displayName = 'ServiceListItem'
